export const ROLES = {
  SAMSUNG: 'samsung',
  VIEWER: 'viewer',
  ORDER: 'order',
  SUPER_ADMIN: 'super-admin',
}
